<template>
  <section
    class="tab-wrap"
    :class="{
      'tab-progress': $slots.bar,
      'tab-sticky-active': isSticky,
      'tab-sticky-header': isHeaderShow,
      'tab-sticky-sub': isSubTab
    }"
    v-bind="$attrs"
  >
    <div class="tab-inner">
      <div class="tab">
        <div class="tab-scroll">
          <router-link
            v-for="(item, key) in tabList"
            ref="tab"
            :key="key"
            :to="{
              name: item.path,
              params: {
                ...item.params,
                locale: $route.params.locale
              },
              query : {
                ...item.query
              },
              hash: item.hash
            }"
            :active-class="index === -1 ? 'active' : 'router-link-active'"
            :class="index > -1 ? {
              active: index === key
            } : ''"
            v-on="$listeners"
            @click.native="onClick"
          >
            {{ $t(item.name) }}
          </router-link>
        </div>
        <slot name="bar" />
      </div>
      <slot name="sub" />
    </div>
  </section>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill'
import { throttle } from 'lodash'

export default {
  name: 'Tab',
  props: {
    index: {
      type: Number,
      default: -1
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isSticky: false,
      isSubTab: true,
      isHeaderShow: false,
      onDebounceHandler: null,
      tabRo: null
    }
  },
  watch: {
    '$route.params.child' () {
      this.goSubTab()
    },
    '$route.params.category' () {
      this.firstElementActive()
      this.tabLine()
    },
    '$route.hash' () {
      this.goSubTab()
    }
  },
  mounted () {
    if (this.$el.classList.contains('tab-sticky')) {
      this.onDebounceHandler = throttle(this.onScroll, 15)
      window.addEventListener('scroll', this.onDebounceHandler)
      this.onScroll()

      this.$root.$on('header-show', (offset) => {
        this.isHeaderShow = offset
      })
    }

    setTimeout(this.tabLineOb, 100)
    this.firstElementActive()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onDebounceHandler)
    this.tabRo.disconnect()
  },
  methods: {
    onScroll () {
      const isPcHeader = window.matchMedia('(min-width: 980px)')
      const headerHeight = isPcHeader.matches ? 72 : 50
      const offsetTop = Math.abs(Math.floor(this.$el.getBoundingClientRect().top))
      const pageHeight = document.documentElement.clientHeight

      if (pageHeight > offsetTop) {
        this.isSticky = offsetTop >= 0 && offsetTop <= headerHeight

        if (this.isHeaderShow && offsetTop < headerHeight) {
          this.$el.querySelector('.tab-inner').style.transform = `translateY(${headerHeight}px)`
          this.isSubTab = false
          this.$root.$emit('tab-sticky', true)
        } else {
          this.$el.querySelector('.tab-inner').style.transform = 'translateY(0px)'
          this.isSubTab = true

          if (offsetTop > headerHeight) {
            this.$root.$emit('tab-sticky', false)
          }
        }
      }

      // requestAnimationFrame(this.onScroll)
    },
    onClick (e) {
      this.$emit('click:tab', e, this)
    },
    tabLine () {
      let lineHeight = 0
      this.$refs.tab.forEach(item => {
        if (lineHeight !== item.$el.offsetTop) {
          lineHeight += item.$el.offsetHeight + 10
          item.$el.dataset.first = 'true'
        } else {
          delete item.$el.dataset.first
        }
      })
    },
    tabLineOb () {
      this.tabRo = new ResizeObserver(entries => {
        entries.forEach(() => {
          this.tabLine()
        })
      })
      this.tabRo.observe(this.$el.querySelector('.tab-scroll'))
    },
    firstElementActive () {
      setTimeout(() => {
        const activeTab = this.$refs.tab.find(item => {
          return !!item.$el.classList.contains('active')
        })

        this.$refs.tab[0].$el.classList.toggle('first-active', !activeTab)
      }, 300)
    },
    goSubTab () {
      setTimeout(() => {
        this.$el.querySelector('.tab-inner').style.transform = 'none'
        this.isSubTab = true
      }, 30)
    }
  }
}
</script>
